import React, { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Charity from './Charity';
import OrderContactInfoWrapper from '../OrderContactInfo/OrderContactInfoWrapper';
import MarketingPreferencesWrapper from '../MarketingPreferences/MarketingPreferencesWrapper';
import SubmitButtonWrapper from '../SubmitButton/SubmitButtonWrapper';
import useSwitchesFromContext from '../../../hooks/useSwitchesFromContext';
import CheckOutRightRail from '../CheckoutRightRail';
import { useIsL } from '../../../hooks/useBreakPoint';
import OrderSubmitLegalTermsWrapper from '../OrderSubmitLegalTerms/OrderSubmitLegalTermsWrapper';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import RepudiationsDialog from '../CheckoutPageRepudiations/RepudiationsDialog';
import Footer from '../../Common/Footer/Footer';

export function CharityPortalComponents() {
  const { getSwitchValue } = useSwitchesFromContext();
  const {
    checkoutPageState,
  } = useContext(CheckoutPageContext);
  const hasOrderContactInfo = getSwitchValue('chkOrderContactInfoMfeEnabled');
  const hasMFESubmitButton = getSwitchValue('chkUseMfeSubmitButton');
  const hasOrderContactToTop = getSwitchValue('chkOrderContactToTop');
  const hasCheckoutMfeRepudiations = getSwitchValue('chkHasMfeCheckoutRepudiations');
  const hasCharity = !!checkoutPageState?.charity;
  const isLBreakPoint = useIsL();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const hasBagMfeV2 = getSwitchValue('chkHasBagMfeV2');
  const hasCharityToRight = getSwitchValue('chkCharityToRight');

  if (!mounted) { return null; }
  return (
    <div className="checkout-mfe-web-service">
      {hasOrderContactInfo && !hasOrderContactToTop && <OrderContactInfoWrapper />}
      {hasOrderContactInfo && !hasOrderContactToTop && <MarketingPreferencesWrapper />}
      {hasCharity && !hasCharityToRight && <Charity />}
      {isLBreakPoint && (
        <div className={`checkout-right-rail-mobile ${hasBagMfeV2 ? 'bag-mfe-V2-right' : ''}`}>
          <CheckOutRightRail parentClass="checkout-right-rail order-summary-wrapper" showPayOverTime={false} />
        </div>
      )}
      <OrderSubmitLegalTermsWrapper />
      {hasMFESubmitButton && <SubmitButtonWrapper />}
      {hasCheckoutMfeRepudiations && checkoutPageState?.orderSubmit?.repudiationData && (
        <RepudiationsDialog />
      )}
      <div className="checkout-footer-mfe" data-testid="checkout-footer-mfe">
        <Footer
          orderId={checkoutPageState?.orderTotals?.orderId}
          tmntData={checkoutPageState?.textFor}
          phoneNumberByCountry={checkoutPageState?.footer?.phoneNumberByCountry}
          phoneNumberByLanguage={checkoutPageState?.footer?.phoneNumberByLanguage}
        />
      </div>
    </div>
  );
}

function CharityPortal() {
  const id = 'charity-portal';
  if (typeof document !== 'undefined' && !!document.getElementById(id)) {
    return ReactDOM.createPortal(
      <CharityPortalComponents />,
      document.getElementById(id),
    );
  }
  return null;
}

export default CharityPortal;
